export enum KpnProvisioningStatus {
  BUSY = 'BUSY',
}
